import { Chip, Icon } from '@aibees/shared/components';
import { classnames, fNumber } from '@aibees/shared/utils';
import { Avatar, Box, LinearProgress, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EmployeeLocationCardProps as Props } from './types';

export const EmployeeLocationCard = memo(
  ({ className, item, hoveredItem }: Props) => {
    const { icon, key, name, percentage, value } = item;
    return (
      <Styled.Wrapper
        className={classnames('EmployeeLocationCard', className)}
        sx={SX.root(Boolean(hoveredItem && hoveredItem === item.key))}
        gap={1.5}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Avatar size={22} variant="rounded" src={icon} />
          <Typography variant="body3" fontWeight={700} color="grey.700">
            {name}
          </Typography>
        </Stack>

        <Box>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Icon name="people-group" size={16} color="grey.500" />
              <Typography variant="body4" fontWeight={300} color="grey.500">
                {fNumber(value)} -Employees
              </Typography>
            </Stack>
            <Chip
              label={`${percentage.toFixed(2)}%`}
              color="default"
              variant="outlined"
              shape="rounded"
              size="xsmall"
            />
          </Stack>
          <LinearProgress variant="determinate" value={percentage} />
        </Box>
      </Styled.Wrapper>
    );
  }
);

EmployeeLocationCard.displayName = 'EmployeeLocationCard';
